"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var InventoryReference = require('./inventory-reference');

var PersonReference = require('../core/person-reference');

var Checkout = /*#__PURE__*/function () {
  function Checkout(opt) {
    _classCallCheck(this, Checkout);

    this.to = null;
    this.inventory = null;
    this.status = null;
    this.date = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(Checkout, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.to = new PersonReference(opt.to);
      this.inventory = new InventoryReference(opt.inventory);
      this.status = opt.status;
      this.date = opt.date ? new Date(opt.date) : new Date();
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'checkout.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          to: {
            type: ['object', 'null']
          },
          inventory: {
            type: ['object', 'null']
          },
          status: {
            type: ['string', 'null']
          },
          date: {
            type: ['object', 'null']
          }
        },
        required: ['to', 'inventory', 'status', 'date']
      };
    }
  }]);

  return Checkout;
}();

tv4.addSchema(InventoryReference.schema());
tv4.addSchema(PersonReference.schema());
module.exports = Checkout;